import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { MasterMatrixTab } from '../../MasterMatrixTab';
import { AmendmentImpactReview } from '../amendment/AmendmentImpactReview';
/**
 * Rebrand of the legacy "Master Matrix" tab — same component, "Amendment
 * History" framing inside the V2 SOURCES rail.
 */ export function SourcesHistoryPage() {
    const { id } = useParams();
    if (!id) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "p-4 sm:p-6 lg:p-8",
        children: [
            /*#__PURE__*/ _jsx(AmendmentImpactReview, {
                projectId: id
            }),
            /*#__PURE__*/ _jsx(MasterMatrixTab, {
                projectId: id
            })
        ]
    });
}
